<template>
  <div>
    <div class="d-flex">
      <v-btn
        class="mr-2"
        color="channelbtn"
        depressed
        @click.stop="addGroupDialog = true"
        dark
      >
        Add
      </v-btn>

      <v-btn
        class="mr-2 white--text "
        color="light-blue darken-4"
        depressed
        @click.stop="openEditGroupDialog()"
        :disabled="btnDisabled"
      >
        Edit
      </v-btn>

      <v-btn
        class="mr-2 "
        color="error"
        depressed
        @click.stop="deleteConfirmDialog = true"
        :disabled="btnDisabled"
      >
        Remove
      </v-btn>
      <v-btn
        class="white--text ml-auto"
        color="blue-grey darken-2"
        depressed
        @click.stop="openMembersEditDialog()"
        :disabled="btnDisabled"
      >
        <v-icon class="mr-1">mdi-account-group</v-icon>Edit Members
      </v-btn>
    </div>
    <div class="mt-4">
      <v-card>
        <v-card-title>
          Group
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="groups"
          :search="search"
          class="border"
          show-select
          :hide-default-footer="false"
          :single-select="singleSelect"
          v-model="selectedGroup"
        >
        </v-data-table>
      </v-card>
    </div>
    <!-- 그룹등록 모달창 -->
    <v-dialog v-model="addGroupDialog" max-width="400px">
      <v-card>
        <div class="d-flex pa-2 align-center channel">
          <v-card-title class="headline white--text">Add Group</v-card-title>
          <div class="ml-auto">
            <v-btn icon @click="closeAddGroupDialog()">
              <v-icon small class="white--text">mdi-window-close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-text class="mt-2 pb-2">
          <v-form ref="form" v-model="valid" v-on:submit.prevent>
            <v-row class="mt-3">
              <v-col cols="12">
                <v-text-field
                  color="channel"
                  label="Group Name"
                  hint="Ex) 인사팀, A부서 ..."
                  :rules="[groupNameRules]"
                  v-model="groupName"
                  :error-messages="errors"
                  prepend-icon="mdi-account-multiple"
                  @keydown.enter="createGroup"
                  @keypress.enter.prevent
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="channelbtn"
            class="mr-2 white--text"
            @click.prevent="createGroup"
          >
            Save
          </v-btn>
          <v-btn
            color="grey"
            class="text-capitalize"
            dark
            @click="closeAddGroupDialog()"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 그룹이름편집 모달창 -->
    <v-dialog v-model="editGroupDialog" max-width="400px">
      <v-card>
        <div class="d-flex pa-2 align-center channel">
          <v-card-title class="headline white--text">Edit Group</v-card-title>
          <div class="ml-auto">
            <v-btn icon @click="closeEditGroupDialog()">
              <v-icon small class="white--text">mdi-window-close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-text class="mt-2 pb-1">
          <v-form ref="form2" v-model="valid">
            <v-row class="mt-3">
              <v-col cols="12">
                <v-text-field
                  color="channel"
                  label="Group Name"
                  hint="Ex) 인사팀, A부서 ..."
                  :rules="[groupEditNameRules]"
                  v-model="groupEditName"
                  :error-messages="errors"
                  prepend-icon="mdi-account-multiple"
                  @keyup.enter="editGroup"
                  @keypress.enter.prevent
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="channelbtn"
            class="mr-2 white--text"
            @click.prevent="editGroup"
          >
            Save
          </v-btn>
          <v-btn
            color="grey"
            class="text-capitalize"
            dark
            @click="closeEditGroupDialog()"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 구성원편집 모달창 -->
    <v-dialog
      v-model="membersEditDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card>
        <div class="d-flex pa-2 align-center channel">
          <v-card-title class="headline white--text">{{
            groupNameMembersEdit
          }}</v-card-title>
          <div class="ml-auto">
            <v-btn
              color="channelbtn"
              class="mr-2 white--text"
              @click.prevent="editMembers()"
            >
              Save
            </v-btn>
            <v-btn
              color="grey"
              class="text-capitalize"
              dark
              @click="closeMembersEditDialog()"
            >
              Cancel
            </v-btn>
            <v-btn icon @click="closeMembersEditDialog()">
              <v-icon small class="white--text">mdi-window-close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-text class="mt-7">
          <v-row>
            <v-col>
              <v-card>
                <v-card-title>
                  Users
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="userSearch"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-card-title>
                <v-data-table
                  v-model="selectedUsers"
                  :headers="headersUser"
                  :items="users"
                  item-key="email"
                  :search="userSearch"
                  class="border"
                  show-select
                >
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- 삭제확인 모달창 -->
    <v-dialog v-model="deleteConfirmDialog" width="500">
      <v-card>
        <div color="error" class="d-flex pa-2 align-center error">
          <v-card-title class="headline white--text">Delete</v-card-title>
          <div class="ml-auto">
            <v-btn icon @click="deleteConfirmDialog = false">
              <v-icon small class="white--text">mdi-window-close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-text class="mt-7">
          <v-icon small>mdi-alert-circle-outline</v-icon> Are you sure you want
          to delete the Group?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            class="mr-2 text-capitalize"
            @click="deleteGroup()"
          >
            Delete
          </v-btn>
          <v-btn
            color="grey"
            class="text-capitalize"
            dark
            @click="deleteConfirmDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { listGroups, listUserRolesByRole } from "@/graphql/Query";
import {
  createGroup,
  updateGroup,
  deleteGroup,
  createUserRoles,
  deleteUserRoles
} from "@/graphql/Mutation";

export default {
  name: "GroupList",

  data: () => ({
    addGroupDialog: false,
    editGroupDialog: false,
    deleteConfirmDialog: false,
    membersEditDialog: false,
    singleSelect: true,
    valid: true,
    groupName: "",
    groupEditName: "",
    errors: [],
    search: "",
    userSearch: "",
    selectedId: "",
    users: [],
    deleteMembers: [],
    createMembers: [],
    selectedGroupMembers: [],
    selectedGroup: [], // 그룹리스트에서 편집, 삭제를 위해 선택된 그룹
    selectedUsers: [],
    headers: [
      {
        text: "name",
        align: "start",
        value: "group_name"
      },
      { text: "id", value: "id" }
    ],
    headersUser: [
      {
        text: "email",
        align: "start",
        value: "email"
      }
    ],
    groups: [],
    groupHeaders: [{ text: "Group", value: "name" }]
  }),

  created() {
    this.initialize();
  },

  computed: {
    btnDisabled: function() {
      return this.selectedGroup.length <= 0;
    },
    groupNameMembersEdit: function() {
      if (this.selectedGroup.length > 0) {
        return this.selectedGroup[0].group_name;
      }
      return "";
    },
    groupIdMembersEdit: function() {
      if (this.selectedGroup.length > 0) {
        return this.selectedGroup[0].id;
      }
      return "";
    }
  },
  methods: {
    async initialize() {
      this.groups = [];
      await this.getListGroups();
    },
    GroupSave() {
      this.addGroupDialog = false;
    },
    async deleteGroup() {
      try {
        console.log();
        const channel_id = this.$store.state.channelId;
        const id = this.selectedGroup[0].id;
        console.log({ channel_id, id });
        const { data } = await this.$apollo.mutate({
          mutation: deleteGroup,
          variables: {
            input: {
              channel_id,
              id
            }
          },
          fetchPolicy: "no-cache"
        });
        if (data && data.deleteGroup) {
          this.$store.dispatch("logger", {
            menu: "Groups",
            level: "success",
            message: `Success to Delete Group [${this.groupNameMembersEdit}] `
          });
          this.groups = this.groups.filter(function(item) {
            return item.id != id;
          });
        }
      } catch (e) {
        // console.log("[GroupList] DeleteGroup failed", e);
        this.$store.dispatch("logger", {
          menu: "Groups",
          level: "error",
          message: `Failed to Delete Group [${this.groupNameMembersEdit}]`
        });
      }
      this.deleteConfirmDialog = false;
    },
    deleteItem(item) {
      this.selectedId = item.id;
      this.deleteGroupDialog = true;
    },
    openEditGroupDialog() {
      this.groupEditName = this.selectedGroup[0].group_name;
      this.editGroupDialog = true;
    },
    openMembersEditDialog() {
      this.membersEditDialog = true;
      this.getListUsers();
    },
    closeEditGroupDialog() {
      this.editGroupDialog = false;
    },
    closeMembersEditDialog() {
      this.membersEditDialog = false;
      this.deleteMembers = [];
      this.createMembers = [];
    },
    closeAddGroupDialog() {
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
      this.addGroupDialog = false;
    },
    async getListGroups() {
      /**
       * 채널에 해당하는 그룹목록 가져오기
       */
      const limit = undefined;
      const nextToken = undefined;
      try {
        const { data } = await this.$apollo.query({
          query: listGroups,
          variables: {
            channel_id: this.$store.state.channelId,
            limit: limit,
            nextToken: nextToken
          },
          fetchPolicy: "no-cache"
        });
        console.log("[GroupList]", data);
        this.groups = data.listGroups.items;
        console.log(this.groups);
        this.groups.sort((a, b) => (a.group_name > b.group_name ? 1 : -1));
      } catch (e) {
        console.log("[GroupList] listGroup failed");
      }
    },
    async createGroup() {
      /**
       * 채널에 해당그룹 생성하기
       */
      if (!this.$refs.form.validate()) return;

      try {
        console.log(this.$store.state.channelId, this.groupName);
        const { data } = await this.$apollo.mutate({
          mutation: createGroup,
          variables: {
            input: {
              channel_id: this.$store.state.channelId,
              group_name: this.groupName
            }
          }
        });
        if (data && data.createGroup) {
          this.groups.push(data.createGroup);
          this.groups.sort((a, b) => (a.group_name > b.group_name ? 1 : -1));

          this.$store.dispatch("logger", {
            menu: "Groups",
            level: "success",
            message: `Success to Add Group ${data.createGroup.group_name}`
          });
        }
      } catch (error) {
        if (error) {
          this.$store.dispatch("logger", {
            menu: "Groups",
            level: "error",
            message: `Fail to Add Group ${this.groupName} `
          });
        }
      }
      this.closeAddGroupDialog();
    },
    async editGroup() {
      /**
       * 채널에 해당그룹 수정하기
       */
      if (!this.$refs.form2.validate()) return;
      const previous_group_name = this.selectedGroup[0].group_name;

      try {
        console.log(
          this.$store.state.channelId,
          this.groupEditName,
          previous_group_name,
          this.selectedGroup[0].id,
          this.groups
        );
        const channel_id = this.$store.state.channelId;
        const group_name = this.groupEditName;
        const id = this.selectedGroup[0].id;

        const { data } = await this.$apollo.mutate({
          mutation: updateGroup,
          variables: {
            input: {
              channel_id,
              group_name,
              id
            }
          }
        });

        if (data && data.updateGroup) {
          const o = this.groups.find(obj => obj.id == id);
          o.group_name = data.updateGroup.group_name;
          this.groups.sort((a, b) => (a.group_name > b.group_name ? 1 : -1));

          this.$store.dispatch("logger", {
            menu: "Groups",
            level: "success",
            message: `Success to Update Group ${previous_group_name} => ${data.updateGroup.group_name}`
          });
        }
      } catch (error) {
        if (error) {
          this.$store.dispatch("logger", {
            menu: "Groups",
            level: "error",
            message: `Fail to Update Group ${previous_group_name} => ${this.groupEditName} `
          });
        }
      }
      this.closeEditGroupDialog();
    },
    async editMembers() {
      const channel_id = this.$store.state.channelId;
      const role = "gu";
      const group_name = this.groupNameMembersEdit;
      const group_id = this.groupIdMembersEdit;

      let deleteResult;
      let createResult;

      // 삭제 목록 작성
      this.selectedGroupMembers.forEach(item => {
        const result = this.selectedUsers.find(item2 => {
          console.log(item.email, item2.email, item == item2);
          return item.email == item2.email;
        });
        console.log({ result });
        if (!result) {
          const x = {};
          x.email = item.email;
          this.deleteMembers.push(x);
        }
      });
      console.log("deleteMembers", this.deleteMembers);

      // 생성 목록 작성
      const diff = [];
      this.users.forEach(item => {
        const result = this.selectedGroupMembers.find(item2 => {
          return item.email == item2.email;
        });
        if (!result) diff.push(item);
      });
      console.log("diff", diff);

      diff.forEach(item => {
        const result = this.selectedUsers.find(
          item2 => item.email == item2.email
        );
        if (result) {
          const x = {};
          x.email = item.email;
          this.createMembers.push(x);
        }
      });
      console.log("createMembers", this.createMembers);

      if (this.deleteMembers.length > 0) {
        console.log("삭제");
        this.deleteMembers.forEach(item => {
          item.channel_id = channel_id;
          item.role = role;
          item.group_id = group_id;
        });
        try {
          const { data } = await this.$apollo.mutate({
            mutation: deleteUserRoles,
            variables: {
              input: this.deleteMembers
            },
            fetchPolicy: "no-cache"
          });
          if (data && data.deleteUserRoles == "done") {
            deleteResult = true;
          }
        } catch (e) {
          console.log("[GroupList] EditMembers 삭제", e);
        }
      }

      if (this.createMembers.length > 0) {
        console.log("생성");
        this.createMembers.forEach(item => {
          item.channel_id = channel_id;
          item.role = role;
          item.group_id = group_id;
        });
        try {
          const { data } = await this.$apollo.mutate({
            mutation: createUserRoles,
            variables: {
              input: this.createMembers
            },
            fetchPolicy: "no-cache"
          });
          if (data && data.createUserRoles == "done") {
            createResult = true;
          }
        } catch (e) {
          console.log("[GroupList] EditMembers 생성", e);
        }
      }

      if (deleteResult || createResult) {
        try {
          this.$store.dispatch("logger", {
            menu: "Groups",
            level: "success",
            message: `Success to Edit Group [ ${group_name} ] members`
          });
        } catch {
          console.log("log error");
        }
      } else {
        try {
          this.$store.dispatch("logger", {
            menu: "Groups",
            level: "error",
            message: `Failed to Edit Group [ ${group_name} ] members`
          });
        } catch {
          console.log("log error");
        }
      }

      this.closeMembersEditDialog();
    },
    groupNameRules(v) {
      if (!v) return "Live Title is required";
      if (v.length > 30) return "Title must be less than 30 characters";
      return true;
    },
    groupEditNameRules(v) {
      if (!v) return "Live Title is required";
      if (v.length > 30) return "Title must be less than 30 characters";
      return true;
    },
    async getListUsers() {
      /**
       * userRole을 role을 기준으로 가져오기
       * 채널##gu 로 채널유저 가져와 이메일 정렬 후 users에 입력
       */
      const limit = undefined;
      const nextToken = undefined;
      const channelId = this.$store.state.channelId;
      // const groupName = this.groupNameMembersEdit;
      const groupId = this.groupIdMembersEdit;

      const userRoleForFull = `${channelId}##gu`;
      const userRoleForSelectedGroup = `${channelId}#${groupId}#gu`;

      // 채널 전체 유저 가져오기
      const { data } = await this.$apollo.query({
        query: listUserRolesByRole,
        variables: {
          user_role: userRoleForFull,
          limit: limit,
          nextToken: nextToken
        },
        fetchPolicy: "no-cache"
      });

      const items = data.listUserRolesByRole.items;
      this.users = items;
      console.log("users", this.users);

      // 선택 그룹에 해당하는 유저 가져오기
      const result = await this.$apollo.query({
        query: listUserRolesByRole,
        variables: {
          user_role: userRoleForSelectedGroup
        },
        fetchPolicy: "no-cache"
      });

      if (result && result.data.listUserRolesByRole.items) {
        this.selectedGroupMembers = [...result.data.listUserRolesByRole.items];
        this.selectedUsers = result.data.listUserRolesByRole.items;
      }
      console.log("selectedGroupMembers", this.selectedGroupMembers);
    }
  }
};
</script>
<style>
.userslist {
  max-height: 200px;
}
</style>
